import { Injectable } from '@angular/core';
import { AppService } from 'src/app/app.service';

@Injectable({ providedIn: 'root' })
export class DynamicLinkService {
  constructor(private appService: AppService) {}
  hasDomainPlaceholder(value: string): boolean { return /\$\{domain\}/i.test(value); }
  replaceDomainPlaceholder(value: string): string {
    if (!value) return value;
    const domain = this.currentDomain;
    return value.replace(/https?:\/\/\$\{domain\}/gi, domain).replace(/\$\{domain\}/gi, domain);
  }
  getInternalPath(value: string): string | null {
    const link = this.replaceDomainPlaceholder(value).trim();
    if (!link || /^\/\//.test(link)) return null;
    if (!/^https?:\/\//i.test(link)) return link;
    try { const url = new URL(link); return url.origin === window.location.origin ? `${url.pathname}${url.search}${url.hash}` : null; } catch { return null; }
  }
  private get currentDomain() { const languageCode = this.appService.languageCode; return languageCode ? `${window.location.origin}/${languageCode}` : window.location.origin; }
}
